/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Accountcompanyname2Inputs */

const en_entity_accountcompanyname2 = /** @type {(inputs: Entity_Accountcompanyname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account Company Name`)
};

const de_entity_accountcompanyname2 = /** @type {(inputs: Entity_Accountcompanyname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto-Firmenname`)
};

/**
* | output |
* | --- |
* | "Account Company Name" |
*
* @param {Entity_Accountcompanyname2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_accountcompanyname2 = /** @type {((inputs?: Entity_Accountcompanyname2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Accountcompanyname2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_accountcompanyname2(inputs)
	return de_entity_accountcompanyname2(inputs)
});
export { entity_accountcompanyname2 as "entity_accountCompanyName" }